import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { 
  Brain, 
  Search, 
  Code, 
  Cpu, 
  Database, 
  GitMerge 
} from 'lucide-react';
import './ServicesSection.css';

const ServicesSection = () => {
  const servicesRow1 = [
    {
      Icon: Brain,
      title: "AI Strategic Planning & Roadmapping",
      description: "We partner with your team to create a comprehensive AI roadmap aligned with your business objectives. Our strategic consultation process includes stakeholder workshops, technical feasibility assessment, and ROI analysis to develop a clear implementation plan. You'll receive a detailed blueprint covering technology selection, resource allocation, timeline planning, and risk mitigation strategies to ensure successful AI adoption."
    },
    {
      Icon: Search,
      title: "Business Impact Analysis & Discovery",
      description: "Our expert team conducts a deep-dive analysis of your operations to uncover high-impact AI opportunities. Using advanced diagnostic tools and industry benchmarks, we evaluate your processes, data infrastructure, and competitive landscape. The result? A prioritized roadmap of AI initiatives with quantified potential returns, helping you make informed decisions about where AI can drive maximum value for your organization."
    },
    {
      Icon: Code,
      title: "Industry-Optimized AI Models",
      description: "Get custom AI models that truly understand your industry's nuances. We specialize in fine-tuning state-of-the-art models (GPT-4, PaLM, Llama 2) with your proprietary data, ensuring they speak your industry's language. Our rigorous testing protocols and domain-specific optimization deliver models that achieve exceptional accuracy and reliability for your unique use cases."
    }
  ];

  const servicesRow2 = [
    {
      Icon: Cpu,
      title: "Custom Generative AI Solutions",
      description: "Transform your business with custom generative AI applications that deliver real results. From intelligent chatbots and content generators to sophisticated AI agents, we handle everything from UX design to deployment. Our solutions combine cutting-edge LLMs with intuitive interfaces, creating powerful tools that automate tasks, enhance creativity, and drive productivity across your organization."
    },
    {
      Icon: Database,
      title: "Enterprise Data Architecture",
      description: "Build the foundation for AI success with our enterprise-grade data engineering services. We architect robust data pipelines that turn raw information into AI-ready assets. Our team handles the complete data lifecycle - from collection and cleaning to enrichment and storage - while implementing best practices in security and governance. The result? A reliable, scalable data infrastructure that powers your AI initiatives."
    },
    {
      Icon: GitMerge,
      title: "AI Systems Integration & Deployment",
      description: "Seamlessly embed AI capabilities into your existing business systems and workflows. Our integration experts ensure your AI solutions work harmoniously with your current tech stack, from CRM and ERP to custom applications. We provide comprehensive documentation, staff training, and ongoing support to ensure your team can effectively leverage these new AI capabilities from day one."
    }
  ];

  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="services-section">
      <div className="title-container">
        <Container>
          <h2 className="section-title">Our Services</h2>
          <p className="section-subtitle">
            We offer comprehensive AI and software development services to help businesses innovate and grow
          </p>
        </Container>
      </div>
      <Container>
        <Row className="mb-5">
          {servicesRow1.map((service, index) => (
            <Col md={4} key={index} className="service-col">
              <div className="service-card">
                <service.Icon className="service-icon" size={32} />
                <h3 className="service-title">{service.title}</h3>
                <p className="service-description">{service.description}</p>
              </div>
            </Col>
          ))}
        </Row>
        <Row>
          {servicesRow2.map((service, index) => (
            <Col md={4} key={index} className="service-col">
              <div className="service-card">
                <service.Icon className="service-icon" size={32} />
                <h3 className="service-title">{service.title}</h3>
                <p className="service-description">{service.description}</p>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
      <div className="services-cta">
        <button className="primary-button" onClick={scrollToContact}>
          Discuss Your Project
        </button>
      </div>
    </section>
  );
};

export default ServicesSection;